

import { Component, OnInit } from '@angular/core';
import { ISO8601_DATE_REGEX } from '@angular/common/src/pipes/date_pipe';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { AtbHomeService } from '../../../services/atbHome.service';
declare var jQuery: any;
import swal2 from "sweetalert2";



@Component({
  selector: 'app-hoteliers-permits-calendar',
  templateUrl: './hoteliers-permits-calendar.component.html',
  styleUrls: ['../../../app.component.css']

})
export class HoteliersPermitsCalendarComponent implements OnInit {

  test;
  idStructure;
  dataCalendarList;
  data: any[] = new Array();
  dataCustomCalendar: any[] = new Array();
  days = ["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"];
  months = ["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"];
  curr;
  numberWeek;
  permitsBasePath;
  pathCalendar;
  stayData: any [] = new Array()
  errorMessage;
  stayFirsDataTemp;
  stayLastDataTemp;
  nameStructure


  constructor(private spinner: NgxSpinnerService, private router: Router, private atbService: AtbHomeService) { }
  ngOnInit() {

    this.curr = new Date();
    this.test = "red"


    this.nameStructure = localStorage.getItem("nameStructureToCalendar")
    this.idStructure = localStorage.getItem("idStructureToCalendar")
    this.permitsBasePath = "permessituristici"
    this.pathCalendar  = "calendario"

    this.numberOfWeek()

  }


  open() {
    jQuery('#sidebar').toggleClass('active');

  console.log('press')

  }





    followWeek() {
      var date =  new Date();
      this.numberWeek = this.numberWeek + 1
      this.getDateOfWeek(this.numberWeek, date.getFullYear())
    }

    previousWeek() {
      var date =  new Date();
      this.numberWeek = this.numberWeek - 1
      this.getDateOfWeek(this.numberWeek, date.getFullYear())
    }



  getCalendar(firstData, lastData) {

    var id = this.idStructure

      this.atbService.getListFilter(this.permitsBasePath + "/" + this.pathCalendar + "/" + id + "?dataInizio="  + firstData +  "&dataFine=" + lastData).subscribe(
        (response) => {
          // Verificare outcome
          if (response.outcome.success === true) {
            this.dataCalendarList = response.results

            // ELABORO I DETTAGLI ALL'INTERNO PER SISTEMARE QUANDO CI SONO SOGGIORNI CHE SI INCROCIANO
            for (let i = 0; i <  this.dataCalendarList.length; i++ ) {
              for (let y = 0; y <  this.dataCalendarList[i].dettaglio.length; y++ ) {
                if (y + 1 !== this.dataCalendarList[i].dettaglio.length) {
                  let dataA = this.getDataFromGiorno(this.dataCalendarList[i].dettaglio[y].giorno)
                  let dataB = this.getDataFromGiorno(this.dataCalendarList[i].dettaglio[y + 1].giorno)
                  if (dataA === dataB) {
                    this.dataCalendarList[i].dettaglio[y]['other'] = true
                    this.dataCalendarList[i].dettaglio[y]['otherData'] = this.dataCalendarList[i].dettaglio[y+1]
                    this.dataCalendarList[i].dettaglio[y + 1]['other'] = false
                  } else {
                    if (this.dataCalendarList[i].dettaglio[y]['other'] !== false) {
                      this.dataCalendarList[i].dettaglio[y]['other'] = true
                    }
                  }
                } else {
                  if (this.dataCalendarList[i].dettaglio[y]['other'] !== false) {
                    this.dataCalendarList[i].dettaglio[y]['other'] = true
                  }
                }
              }
            }
            console.log('Lista Calendario', this.dataCalendarList);
          } else {

          }
        },
        (error) => {
          console.log('Error ', error);
         // this.goToAtbAtHome();
        })
    }

  getDataFromGiorno(data) {
    let dataSplitted = data.split(" ");

    return dataSplitted[0];
  }

  isInMiddleOfTheDays(data) {
    let dataSplitted = data.split(" ");
    return dataSplitted[1] === "23:59:59";
  }

  isInMiddleOfTheDaysHour(data) {
    let dataSplitted = data.split(" ");
    return dataSplitted[1];
  }
  numberOfWeek() {
    var date = new Date()
    var onejan = new Date(date.getFullYear(), 0, 1);




       // tslint:disable-next-line:max-line-length
       var a =  Math.ceil((((+new Date(date.getFullYear(), date.getMonth(), date.getDate()) - +onejan) / 86400000) + onejan.getDay() + 1) / 7);
      console.log(a)

      this.numberWeek = a;



      this.getDateOfWeek(a,  date.getFullYear())


  }


  getDateOfWeek(w, y) {

    this.data = []
    var d = (1 + (w - 1) * 7); // 1st of January + 7 days for each week
    var result =  new Date(y, 0, d);


    for (var i = 0; i < 7; i++) {
     if(i == 0){

     }else{
      result = this.addDays(result, 1)
      console.log(result)
     }
      var  day = {
       day: result.getDate(),
       nameDay: this.days[result.getDay()],
       month: result.getMonth() + 1,
       year: result.getFullYear()
     }

     this.data.push(day)
    }

    console.log(result)
    console.log(this.data)
    this.stayData = []

    var monthsFirst = this.data[0]['month']
    if  (  this.data[0]['month'] < 10) {
         monthsFirst = "0" + this.data[0]['month']
    }

    var monthsSecond = this.data[6]['month']
    if  (  this.data[6]['month'] < 10) {
      monthsSecond = "0" + this.data[6]['month']
 }


 var dayFirst = this.data[0]['day']
 if  (  this.data[0]['day'] < 10) {
  dayFirst = "0" + this.data[0]['day']
}

var daySecond = this.data[6]['day']
 if  (  this.data[6]['day'] < 10) {
  daySecond = "0" + this.data[6]['day']
}



    var dataStringFirstServer = this.data[0]['year'] + "-" +  monthsFirst + "-" + dayFirst
    var dataStringLastServer = this.data[6]['year'] + "-" + monthsSecond + "-" + daySecond

    this.stayFirsDataTemp =  dataStringFirstServer;
    this.stayLastDataTemp = dataStringLastServer

    this.stayData.push(dataStringFirstServer)
    this.stayData.push(dataStringLastServer)

    console.log(this.stayData)



    this.getCalendar( this.stayData[0], this.stayData[1])


}

onChange(eve: any, editObject) {
console.log("cambio", editObject)

this.spinner.show()


if (editObject.sosta == false) {

  editObject.sosta = true

} else {
  editObject.sosta = false
}


this.atbService.edit(editObject, this.permitsBasePath + '/' + this.pathCalendar).subscribe(
  response => {


    if (response.outcome.success === true) {

  if ( editObject.sosta == true ) {

    this.getPdfFromtransaction(editObject.id)
    swal2("Il permesso di sosta è stato inserito", "", "success")
} else {
    swal2("Il permesso di sosta è stato rimosso", "", "success")
  }


    this.spinner.hide()
console.log(response)




    } else {

      this.dataCalendarList = []
this.getCalendar( this.stayFirsDataTemp, this.stayLastDataTemp)
      this.errorMessage =
        response.outcome.code + response.outcome.description;

        if ( editObject.sosta == true ) {
          swal2("Il permesso di sosta non è stato inserito", "", "warning");
      } else {
          swal2("Il permesso di sosta non  è stato rimosso", "", "warning")
        }


     // swal2('Attenzione', this.errorMessage, 'warning');
     this.spinner.hide()
     console.log(response)
    }
  },
  error => {
    // this.logger.log("Error", error, 200);
    this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
    this.spinner.hide()
  }
);


}

closeCalendar() {
  this.router.navigate(['/hoteliers/manage']);

}


addDays(result, days) {

  result.setDate(result.getDate() + days);
  return result;
}


getPdfFromtransaction(id) {
  console.log(id)


  this.atbService.getFilePdf('download?id=' + id + '&type=sostapermeturi').subscribe(
    response => {
      if (response) {

        console.log ("RISPOSTA" , response)

        var blob = new Blob([response], { type: 'application/pdf' });
        var ieEDGE = navigator.userAgent.match(/Edge/g);
        var ie = navigator.userAgent.match(/.NET/g); // IE 11+
        var oldIE = navigator.userAgent.match(/MSIE/g);

        console.log('COSA E?', ieEDGE )
        console.log(blob)
        if (ie || oldIE || ieEDGE) {

          console.log(' EDGE !')
          window.navigator.msSaveOrOpenBlob(blob, 'myPDFdoc.pdf');
        } else {
          console.log(' NON E\' EDGE !')
          var url = window.URL.createObjectURL(blob);
          //   window.open(url);

          //   window.navigator.msSaveOrOpenBlob(blob, 'myPDFdoc.pdf');

          var link = document.createElement('a');
          link.href = url;
          link.download = "file.pdf";
          link.click();
        }
        swal2('Il pdf è stato scaricato', '', 'success');

      } else {

      }
    },
    error => {
      console.log ("RISPOSTA" , error)
      swal2(
        'Errore',
        'Spiacente, si è verificato un errore tecnico.',
        'error'
      );
    }
  );
}





}



// WEBPACK FOOTER //
// ./src/app/views/hoteliers-permits/hoteliers-permits-calendar/hoteliers-permits-calendar.component.ts